// 何もしないPromiseを返す
export default function pass(): Promise<void> {
    return new Promise(resolve => resolve());
}
